import styled from 'styled-components';
import { Button } from 'components';
import { DropdownMenuItem } from 'components/dropdown/dropdown';

export const FooterContainer = styled.div.attrs({
  className:
    'flex max-h-full shrink-0 flex-col gap-3 overflow-y-auto border-t border-border bg-card p-3',
})``;

export const FooterButtonRow = styled.div.attrs({
  className: 'flex items-center gap-3',
})``;

export const BackButton = styled(Button).attrs({
  variant: 'outline',
  className: 'h-[48px] gap-1.5 bg-card px-2.5 py-2 dark:bg-card',
})``;

export const RecordingActionGroup = styled.div.attrs({
  className: 'flex min-w-0 flex-1 items-stretch',
})``;

export const RecordingActionButton = styled(Button).attrs<{ $roundedFull?: boolean }>((props) => ({
  className: [
    'h-[48px] min-w-0 flex-1 items-center justify-start gap-1.5 px-2.5 py-2 disabled:cursor-not-allowed disabled:opacity-60',
    props.$roundedFull ? 'rounded-md' : 'rounded-l-md rounded-r-none',
  ].join(' '),
}))<{ $roundedFull?: boolean }>``;

export const ResumeRecordingButton = styled(Button).attrs({
  className: 'h-[48px] min-w-0 flex-1 gap-1.5 rounded-lg px-2.5 py-2',
})``;

export const RecordingActionLabel = styled.span.attrs({
  className: 'flex min-w-0 flex-1 flex-col items-start text-left',
})``;

export const RecordingActionTitle = styled.span.attrs({
  className: 'truncate text-sm font-medium',
})``;

export const RecordingActionSubtitle = styled.span.attrs({
  className: 'truncate text-xs opacity-50',
})``;

export const LanguageMenuTrigger = styled(Button).attrs({
  className: 'h-[48px] rounded-l-none rounded-r-md border-l border-white/20 px-2.5 py-2',
})``;

export const LanguageMenuHeader = styled.div.attrs({
  className: 'flex flex-col gap-1 px-2 py-1.5',
})``;

export const LanguageMenuTitle = styled.span.attrs({
  className: 'text-xs font-semibold text-foreground',
})``;

export const LanguageMenuDescription = styled.span.attrs({
  className: 'text-xs text-muted-foreground',
})``;

export const LanguageOption = styled(DropdownMenuItem).attrs<{ $selected?: boolean }>((props) => ({
  className: [
    'focus:bg-muted focus:text-foreground',
    props.$selected ? 'bg-muted text-foreground' : 'text-muted-foreground',
  ].join(' '),
}))<{ $selected?: boolean }>``;

export const NoRecordingOption = styled(DropdownMenuItem).attrs({
  className: 'justify-center bg-muted font-medium focus:bg-muted focus:text-foreground',
})``;

export const LanguageOptionCode = styled.span.attrs<{ $selected?: boolean }>((props) => ({
  className: [
    'flex h-4 w-7 shrink-0 items-center justify-center rounded-sm text-[10px] font-semibold',
    props.$selected
      ? 'bg-primary text-primary-foreground'
      : 'border border-border bg-background text-foreground',
  ].join(' '),
}))<{ $selected?: boolean }>``;

export const LanguageOptionLabel = styled.span.attrs({
  className: 'flex-1',
})``;

export const LanguageOptionMeta = styled.span.attrs({
  className: 'text-xs text-muted-foreground',
})``;
